import { useEffect } from 'react';

const setMeta = (name, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setLink = (rel, href) => {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const setOgProperty = (property, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

/**
 * Sets per-route SEO metadata: <title>, meta description, canonical, and basic OG tags.
 */
export const usePageMeta = ({ title, description, canonical, ogTitle, ogDescription }) => {
  useEffect(() => {
    if (title) document.title = title;
    setMeta('description', description);
    setLink('canonical', canonical);
    setOgProperty('og:title', ogTitle || title);
    setOgProperty('og:description', ogDescription || description);
    setOgProperty('og:url', canonical);
    setOgProperty('og:type', 'website');
  }, [title, description, canonical, ogTitle, ogDescription]);
};
